import React from "react";

const FinalStep = ({ step, setStep }) => {
  return (
    <>
      <form className="Wrpper d-flex flex-column  gap-4 ">
        <div className="">
          <button
            onClick={() => setStep(4)}
            className="border-0 p-0 d-flex align-items-center  gap-10 "
          >
            {backBtn} Home
          </button>
        </div>
        <div className="">
          <div className="head">
            <h2 className="m-0 fw-sbold text-[24px]">Genrate Avtaar</h2>
          </div>
          <div className="py-5 d-flex flex-column   gap-10 ">
            <div className="">
              <div className="grid gap-5 grid-cols-12">
                <div className="md:col-span-6 col-span-12">
                  <img
                    src={"/assets/media/model.png"}
                    alt=""
                    // height={10000}
                    // width={10000}
                    className="max-w-full h-auto w-full rounded"
                  />
                  <div className="py-3 text-center">
                    <h6 className="m-0 dark:text-[#D9D8DC] text-[15px] text-[#666]">
                      Character name
                    </h6>
                    <p className="m-0 font-bold text-[15px]">Sundy</p>
                    <div className="">
                      <button
                        // onClick={() => setStep(4)}
                        className="d-flex align-items-center mt-5  justify-content-center  commonBtn gap-2 h-[40px]  rounded-circle  w-full max-w-[377px] mx-auto"
                      >
                        Chat <span className="icn">{chatIcn}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="md:col-span-6 col-span-12">
                  <div className="grid  gap-10  grid-cols-12 dark:text-[#D9D8DC] text-[#666] text-[15px] max-w-[410px] mx-auto">
                    <div className="sm:col-span-4 col-span-6 my-2">
                      <label htmlFor="" className="form-label m-0">
                        Name
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        Rosey
                      </p>
                    </div>
                    <div className="sm:col-span-4 col-span-6 my-2">
                      <label htmlFor="" className="form-label m-0">
                        DOB
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        5/1/1999
                      </p>
                    </div>
                    <div className="sm:col-span-4 col-span-6 my-2">
                      <label htmlFor="" className="form-label m-0">
                        Personality
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        Personality
                      </p>
                    </div>
                    <div className="sm:col-span-4 col-span-6 my-2">
                      <label htmlFor="" className="form-label m-0">
                        Education
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        Straight
                      </p>
                    </div>
                    <div className="sm:col-span-4 col-span-6 my-2">
                      <label htmlFor="" className="form-label m-0">
                        Profession
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        Brunette
                      </p>
                    </div>
                    <div className="sm:col-span-4 col-span-6 my-2">
                      <label htmlFor="" className="form-label m-0">
                        Gender
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        Medium
                      </p>
                    </div>
                    <div className="sm:col-span-4 col-span-6 my-2">
                      <label htmlFor="" className="form-label m-0">
                        Hobbies
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        Sport
                      </p>
                    </div>
                    <div className="sm:col-span-4 col-span-6 my-2">
                      <label htmlFor="" className="form-label m-0">
                        Hobbies
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        Travel
                      </p>
                    </div>
                    <div className="sm:col-span-4 col-span-6 my-2">
                      <label htmlFor="" className="form-label m-0">
                        Hobbies
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        Gaming
                      </p>
                    </div>
                    <div className="col-span-12 my-2">
                      <label htmlFor="" className="form-label m-0">
                        Enter Life Story
                      </label>
                      <p className="m-0 font-bold dark:text-white text-[#333]">
                        Lorem ipsum dolor sit amet consectetur. Sit massa
                        aliquam odio morbi at lacus ut. Porta lobortis sed
                        ligula amet proin iaculis ipsum viverra neque. Leo
                        tortor lacus in leo.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default FinalStep;

const chatIcn = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.252 18.5065C12.8849 18.4632 13.5125 18.3621 14.127 18.2045C14.886 18.4326 15.687 18.4843 16.469 18.3555C16.5002 18.3517 16.5316 18.3494 16.563 18.3485C16.842 18.3485 17.208 18.5085 17.742 18.8455V18.2915C17.7422 18.195 17.7683 18.1003 17.8176 18.0173C17.8668 17.9343 17.9374 17.866 18.022 17.8195C18.2547 17.6882 18.4697 17.5405 18.667 17.3765C19.445 16.7265 19.884 15.8585 19.884 14.9405C19.884 14.6375 19.836 14.3355 19.741 14.0475C19.977 13.6135 20.165 13.1605 20.305 12.6885C20.755 13.3535 20.997 14.1385 21 14.9405C21 16.1885 20.412 17.3525 19.393 18.2035C19.2223 18.3455 19.044 18.4762 18.858 18.5955V19.8935C18.858 20.3395 18.336 20.5965 17.968 20.3305C17.6193 20.0739 17.2589 19.8337 16.888 19.6105C16.7808 19.5487 16.67 19.4936 16.556 19.4455C16.2464 19.4913 15.9339 19.5144 15.621 19.5145C14.351 19.5145 13.177 19.1375 12.252 18.5065ZM5.531 15.9115C3.927 14.5685 3 12.7375 3 10.7755C3 6.7675 6.832 3.5625 11.511 3.5625C16.191 3.5625 20.024 6.7665 20.024 10.7755C20.024 14.7835 16.191 17.9875 11.511 17.9875C10.985 17.9875 10.4667 17.9475 9.956 17.8675C9.736 17.9185 8.854 18.4355 7.584 19.3505C7.124 19.6825 6.472 19.3625 6.472 18.8035V16.5905C6.14262 16.3869 5.82846 16.1596 5.532 15.9105M9.987 16.5025C10.0257 16.5025 10.0647 16.5055 10.104 16.5115C10.564 16.5875 11.033 16.6258 11.511 16.6265C15.464 16.6265 18.627 13.9815 18.627 10.7745C18.627 7.5685 15.464 4.9235 11.512 4.9235C7.56 4.9235 4.395 7.5705 4.395 10.7755C4.395 12.3255 5.135 13.7855 6.441 14.8785C6.77033 15.1532 7.129 15.3998 7.517 15.6185C7.62225 15.6769 7.71011 15.7622 7.7716 15.8657C7.83309 15.9692 7.86601 16.0871 7.867 16.2075V17.4835C8.872 16.8185 9.533 16.5025 9.987 16.5025Z"
      fill="white"
    />
    <path
      d="M8.0625 12C8.36087 12 8.64702 11.8815 8.858 11.6705C9.06897 11.4595 9.1875 11.1734 9.1875 10.875C9.1875 10.5766 9.06897 10.2905 8.858 10.0795C8.64702 9.86853 8.36087 9.75 8.0625 9.75C7.76413 9.75 7.47798 9.86853 7.267 10.0795C7.05603 10.2905 6.9375 10.5766 6.9375 10.875C6.9375 11.1734 7.05603 11.4595 7.267 11.6705C7.47798 11.8815 7.76413 12 8.0625 12ZM11.7195 12C12.0179 12 12.304 11.8815 12.515 11.6705C12.726 11.4595 12.8445 11.1734 12.8445 10.875C12.8445 10.5766 12.726 10.2905 12.515 10.0795C12.304 9.86853 12.0179 9.75 11.7195 9.75C11.4211 9.75 11.135 9.86853 10.924 10.0795C10.713 10.2905 10.5945 10.5766 10.5945 10.875C10.5945 11.1734 10.713 11.4595 10.924 11.6705C11.135 11.8815 11.4211 12 11.7195 12ZM15.3755 12C15.6739 12 15.96 11.8815 16.171 11.6705C16.382 11.4595 16.5005 11.1734 16.5005 10.875C16.5005 10.5766 16.382 10.2905 16.171 10.0795C15.96 9.86853 15.6739 9.75 15.3755 9.75C15.0771 9.75 14.791 9.86853 14.58 10.0795C14.369 10.2905 14.2505 10.5766 14.2505 10.875C14.2505 11.1734 14.369 11.4595 14.58 11.6705C14.791 11.8815 15.0771 12 15.3755 12Z"
      fill="white"
    />
  </svg>
);

const backBtn = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.921 7.5L7.714 13.292L7 14L0 7L7 0L7.714 0.708L1.92 6.5H14V7.5H1.921Z"
      fill="currentColor"
    />
  </svg>
);
